<script setup lang="ts">
import BaseCheckBox from '@/shared/components/check-box/BaseCheckBox.vue'

interface Props {
  title: string
  label?: boolean
  disabled?: boolean
  value?: string | number
}

defineOptions({ inheritAttrs: false })
const props = defineProps<Props>()
const model = defineModel<boolean>({ required: true })

const onToggle = () => {
  if (!props.disabled) {
    model.value = !model.value
  }
}
</script>
<template>
  <div class="relative flex items-center cursor-pointer" @click="onToggle" v-bind="$attrs">
    <BaseCheckBox v-model="model" :disabled="disabled" />
    <label
      v-if="label"
      class="font-light text-sm text-nowrap cursor-pointer ms-2"
      :class="disabled ? 'text-gray-400 dark:text-gray-800' : 'text-gray-700 dark:text-gray-400'"
    >
      {{ title }}
    </label>
  </div>
</template>
